import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HttpClient } from '@angular/common/http';
import { AttributeSet } from '../models/attribute';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class AttributesetService {
  url2 = environment.serverAPI4 + "/api/eavattributeset";
  constructor(
    private http: HttpClient
  ) { }

  searchAttributeSet(query, Page: any, size: any, sort: any,typeId:any): Observable<Object> {
    return this.http.get(`${this.url2}/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}&typeId=${typeId}`);
  }

  getattributeSetId(attrId: number): Observable<Object> {
    return this.http.get(`${this.url2}/${attrId}`);
  }
  getAttributeSet(Page: number, size: number, sort: number,typeId:any): Observable<Object> {
    return this.http.get(`${this.url2}?page=${Page}&size=${size}&sort=${sort}&typeId=${typeId}`);
  }
  getAttributeSetDropDown(typeId:any): Observable<Object> {
    return this.http.get(`${this.url2}/dropdown?typeId=${typeId}`);
  }

  getAttributeSetDropDownList(typeId:any): Observable<Object> {
    return this.http.get(`${this.url2}/dropdown/list?typeId=${typeId}`);
  }

  createAttributeSetFromExisting(attributeSet: AttributeSet): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url2}/add`, attributeSet);
  }

  checkDuplicateAttributeSetName(attributeSetName: any): Observable<Object> {
    return this.http.get(`${this.url2}/setnameExists/${attributeSetName}`);
  }

  createAttributeSet(attributeSet: AttributeSet): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url2}/new`, attributeSet);
  }
}
